    <!--begin::Quick links-->
    <div ngbDropdown>
      <!--begin::Menu wrapper-->
      <div ngbDropdownToggle>
        <ng-content></ng-content>
      </div>

      <!--begin::Menu 2-->
      <div ngbDropdownMenu class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
        <!--begin::Menu item-->
        <div class="menu-item px-3">
          <div class="menu-content fs-6 text-dark fw-bold px-3 py-4">Quick Actions</div>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu separator-->
        <div class="separator mb-3 opacity-75"></div>
        <!--end::Menu separator-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
          <a href="#" class="menu-link px-3">New Transaction</a>
        </div>
        <!--end::Menu item-->

        <!--begin::Menu separator-->
        <div class="separator mt-3 opacity-75"></div>
        <!--end::Menu separator-->
        <!--begin::Menu item-->
        <div class="menu-item px-3">
          <div class="menu-content px-3 py-3">
            <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
          </div>
        </div>
        <!--end::Menu item-->
      </div>
      <!--end::Menu 2-->
      <!--end::Menu wrapper-->
    </div>
    <!--end::Quick links-->
